export default __webpack_public_path__ + "static/media/graphic-01.53c8839c.png";